import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', function () {
    const baseUrl = '/api/reports';
    let swiper2;

    async function paginArh(url) {
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const data = await response.json();
            clearSlider();
            updateReportsSlider(data);
            initSwiper();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    paginArh(baseUrl);

    function clearSlider() {
        const sliderContainer = document.querySelector('.report-slider');
        if (sliderContainer) {
            sliderContainer.innerHTML = '';
        }
    }

    const categoryItemsAll = document.querySelectorAll('.reports-category__items');
    categoryItemsAll.forEach(item => {
        item.addEventListener('click', function () {
            const categoryId = item.dataset.category;
            const url = `/api/reports?page=1&tag_id=${categoryId}&per_page=1000`;
            removeActive();
            item.classList.add('active-filter');
            paginArh(url);
        });
    });

    function updateReportsSlider(data) {
        const sliderContainer = document.querySelector('.report-slider');
        if (sliderContainer && data.data) {
            data.data.forEach(item => {
                const itemElement = createReportElement(item);
                sliderContainer.appendChild(itemElement);
            });
        }
    }

    function createReportElement(item) {
        const itemElement = document.createElement('div');
        itemElement.classList.add('report-wrapper__item', 'swiper-slide');
        itemElement.setAttribute('data-category__filter', `${item.tag_id}`);
        itemElement.onclick = () => {
            window.location.href = `/reports/${item.slug}`;
        };
        itemElement.innerHTML = `
            <div class="img-wrapper">
                <img loading="lazy" src="${item.image}" alt="photo">
                <a href="/reports/${item.slug}" class="image-text"> Детальніше</a>
            </div>
            <div class="slider-text">
                <div class="slider-text__category">${item.tag}</div>
                <h4 class="slider-text__title">${item.title}</h4>
                <div class="slider-text__desc">${item.short_description}</div>
                <div class="slider-remained__wrapper">
                   <template x-if="${item.earned_amount}!==0">
                    <div class="text">Зібрано</div>
                </template>
                   <template x-if="${item.earned_amount}!==0">
                    <div class="slider-remained__wrapper-value">${item.earned_amount} грн</div>
                    </template>
                </div>
            </div>
            <a href="/reports/${item.slug}" class="support">Детальніше</a>`;
        return itemElement;
    }

    function initSwiper() {
        if (swiper2) {
            swiper2.destroy();
        }
        swiper2 = new Swiper('.report-wrapper__slider', {
            direction: 'horizontal',
            centeredSlides: false,
            slidesPerView: 4,
            spaceBetween: 32,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next1",
                prevEl: ".swiper-button-prev1",
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
            },
            breakpoints: {
                100: { slidesPerView: 1.3, spaceBetween: 20, loop: true, centeredSlides: false },
                640: { slidesPerView: 1, spaceBetween: 20, centeredSlides: true },
                780: { slidesPerView: 2, spaceBetween: 32 },
                1140: { slidesPerView: 4, spaceBetween: 32 },
                10000: { slidesPerView: 4, spaceBetween: 32 },
            },
        });
    }

    function removeActive() {
        const categoryItemsAll = document.querySelectorAll('.reports-category__items');
        categoryItemsAll.forEach(otherItem => {
            otherItem.classList.remove('active-filter');
        });
    }
});
